import React from 'react'
import { IIcon } from './Icon.interface'
import { IconTestIds } from './iconTestIds'

export const FeatureChechmarkIcon = ({ classes }: IIcon) => (
  <svg
    data-testid={IconTestIds.FeatureCheckmark}
    className={classes}
    width="23"
    height="24"
    viewBox="0 0 23 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="23" height="24" rx="11.5" fill="#F5F5F5" />
    <path
      d="M9.71878 18C9.41726 18 9.21625 17.8998 9.01523 17.5994L6.10051 13.1924C5.89949 12.892 6 12.3912 6.40203 12.0907C6.70355 11.8904 7.20609 11.9906 7.40711 12.3912L9.71878 15.7965L10.0203 15.2957C10.0203 15.2957 10.0203 15.1956 10.1208 15.1956L10.6234 14.5946L12.533 11.7902L13.0355 11.1893V11.0891L14.0406 9.88725L14.9452 8.48504C14.9452 8.48504 14.9452 8.38489 15.0457 8.38489L15.5482 7.78394L15.9503 6.98268C16.0508 6.98268 16.0508 6.98268 16.0508 6.88253L16.6538 6.28158C16.9553 5.98111 17.4579 5.88095 17.7594 6.18142C18.0609 6.4819 18.0609 6.98268 17.8599 7.28316L17.3574 7.8841L16.9553 8.5852L16.8548 8.68536L16.3523 9.2863L15.4477 10.6885C15.4477 10.6885 15.4477 10.7887 15.3472 10.7887L14.3421 12.0907L13.9401 12.6917L11.93 15.5962C11.93 15.5962 11.93 15.6964 11.8294 15.6964L11.3269 16.2973L10.4223 17.6995C10.2213 17.8998 10.0203 18 9.71878 18Z"
      fill="currentColor"
    />
  </svg>
)
